import React from "react";
// import { IoIosArrowDown } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { useGetAllBannersQuery } from "../../redux/bannerApi";
// import { ImBin } from "react-icons/im";
// import { MdOutlineModeEditOutline } from "react-icons/md";

const Banner = () => {
  const { data, error, isLoading, isFetching } = useGetAllBannersQuery();
  console.log(error);

  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Banners
        </p>
        <div className="flex  items-center">
          <NavLink
            to={"/banners/create-banner"}
            className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
          >
            + Add New Banner
          </NavLink>
        </div>
      </div>
      {isFetching || isLoading ? (
        <div className="flex flex-col gap-3">
          <div className=" w-full aspect-[3/1] bg-[#EFEFEF] rounded-xl animate-pulse"></div>
          <div className=" w-full aspect-[3/1] bg-[#EFEFEF] rounded-xl animate-pulse"></div>
          <div className=" w-full aspect-[3/1] bg-[#EFEFEF] rounded-xl animate-pulse"></div>
        </div>
      ) : (
        data &&
        (data?.banners?.length === 0 ? (
          <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
            No Banner Found
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:gap-5 gap-3">
            {data?.banners?.map((banner) => (
              <NavLink
                key={banner._id}
                className=" relative"
                to={`/banners/update-banner/${banner._id}`}
              >
                <img
                  src={banner?.imageUrl}
                  className=" lg:rounded-xl rounded-lg"
                  alt=""
                />
                {/* <div className=" absolute z-[1] top-3 right-3">
                  <MdOutlineModeEditOutline className="text-blue-600" />
                  <ImBin className="text-red-600" />
                </div> */}
              </NavLink>
            ))}
          </div>
        ))
      )}
      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message}
        </p>
      )}
    </div>
  );
};

export default Banner;
